
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wines/[slug]/[...vintage]",
      function () {
        return require("private-next-pages/wines/[slug]/[...vintage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wines/[slug]/[...vintage]"])
      });
    }
  